import React, { useState, useMemo } from 'react';
import { ReportCicloOrcamentario, GraficoEconomicoPlureAnualProjeto } from '../../api/relatorios';
import GraficoCurvaPluriAnual from '../GraficoCurvaPluriAnual/index'

interface PropGraficoPluriAnual {
    projetoId: string;
    exportarCurvaEconomicaPluriAnual?: boolean;
}


const GraficoPluriAnual = ({ projetoId, exportarCurvaEconomicaPluriAnual }: PropGraficoPluriAnual) => {

    const [relatorio, setRelatorio] = useState<ReportCicloOrcamentario>();

    useMemo(() => {
        if (projetoId) {
            GraficoEconomicoPlureAnualProjeto(projetoId).then((data) => {
                if (data) {
                    if (data.serieDataForeCastLinha) {
                        for (var i = 0; i < data.serieDataForeCastLinha.length; i++) {
                            if (data.serieDataForeCastLinha[i] <= 0) {
                                data.serieDataForeCastLinha[i] = null;
                            }
                        }
                    }

                    if (data.serieDataOrcadoLinha) {
                        for (var i = 0; i < data.serieDataOrcadoLinha.length; i++) {
                            if (data.serieDataOrcadoLinha[i] <= 0) {
                                data.serieDataOrcadoLinha[i] = null;
                            }
                        }
                    }

                    if (data.serieDataExecutadoLinha) {
                        for (var i = 0; i < data.serieDataExecutadoLinha.length; i++) {
                            if (data.serieDataExecutadoLinha[i] <= 0) {
                                data.serieDataExecutadoLinha[i] = null;
                            }
                        }
                    }


                    if (data.serieDataExecutado) {
                        for (var i = 0; i < data.serieDataExecutado.length; i++) {
                            if (data.serieDataExecutado[i] <= 0) {
                                data.serieDataExecutado[i] = null;
                            }
                        }
                    }

                    if (data.serieDataOrcado) {
                        for (var i = 0; i < data.serieDataOrcado.length; i++) {
                            if (data.serieDataOrcado[i] <= 0) {
                                data.serieDataOrcado[i] = null;
                            }
                        }
                    }

                    if (data.serieDataForeCast) {
                        for (var i = 0; i < data.serieDataForeCast.length; i++) {
                            if (data.serieDataForeCast[i] <= 0) {
                                data.serieDataForeCast[i] = null;
                            }
                        }
                    }

                }
                setRelatorio(data);
            });
        }
    }, [projetoId]);

    return (
        <>
            {relatorio ? <GraficoCurvaPluriAnual
                relatorio={relatorio}
                carregarTabela={true}
                exportarCurvaEconomicaPluriAnual={exportarCurvaEconomicaPluriAnual}
                projetoId={projetoId}
            /> : <> </>}
        </>
    );
};

export default GraficoPluriAnual;
